import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { Layout } from "@/layout";
import brand from "@/config/brand";

/** 每个后台页单独挂 Layout，避免 path:'' / path:'/' 抢走公开首页 `/` */
function withLayout(
  path: string,
  name: string,
  title: string,
  component: RouteRecordRaw["component"]
): RouteRecordRaw {
  return {
    path,
    component: Layout,
    children: [
      {
        path: "",
        name,
        meta: { title },
        component,
      },
    ],
  };
}

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "landing",
    meta: {
      title: `Google Ads Management Platform | ${brand.name}`,
      public: true,
    },
    component: () => import("../views/PublicHome.vue"),
  },
  {
    path: "/privacy-policy",
    name: "privacyPolicy",
    meta: { title: `Privacy Policy | ${brand.name}`, public: true },
    component: () => import("../views/PrivacyPolicy.vue"),
  },
  {
    path: "/terms",
    name: "terms",
    meta: { title: `Terms of Service | ${brand.name}`, public: true },
    component: () => import("../views/Terms.vue"),
  },
  {
    path: "/login",
    name: "login",
    meta: { title: "登陆", public: true },
    component: () => import("../views/Login.vue"),
  },
  withLayout("/index", "index", "首页", () => import("../views/HomeView.vue")),
  withLayout("/countApply", "countApply", "首页", () => import("../views/CountApply.vue")),
  withLayout("/countProgress", "countProgress", "开户进度", () => import("../views/AboutView.vue")),
  withLayout("/AccountCount", "AccountCount", "帐户统计", () => import("../views/AccountCount.vue")),
  withLayout("/AccountRun", "AccountRun", "帐户运行", () => import("../views/AccountRun.vue")),
  withLayout("/chargeProgress", "chargeProgress", "充值进度", () => import("../views/ChargeProgress.vue")),
  withLayout("/ChargeRecord", "ChargeRecord", "充值记录", () => import("../views/ChargeRecord.vue")),
  withLayout("/AccountEmail", "AccountEmail", "帐户授权列表", () => import("../views/AccountEmail.vue")),
  withLayout("/ChargeReport", "ChargeReport", "帐户消耗报告", () => import("../views/ChargeReport.vue")),
  withLayout("/CountList", "CountList", "帐户列表", () => import("../views/CountList.vue")),
  withLayout("/CompanyConsume", "CompanyConsume", "企业消耗", () => import("../views/CompanyConsume.vue")),
  withLayout("/CompanyMon", "CompanyMon", "月度统计", () => import("../views/CompanyMon.vue")),
  withLayout("/CompanyWeek", "CompanyWeek", "周统计", () => import("../views/CompanyWeek.vue")),
  withLayout("/Wallet", "Wallet", "钱包流水", () => import("../views/Wallet.vue")),
  withLayout("/CompanyInfo", "CompanyInfo", "企业信息", () => import("../views/CompanyInfo.vue")),
  withLayout("/CompanyList", "CompanyList", "企业列表", () => import("../views/CompanyList.vue")),
  withLayout("/Team", "Team", "团队管理", () => import("../views/Team.vue")),
  withLayout("/User", "User", "我的资料", () => import("../views/User.vue")),
  withLayout("/WalletProgress", "WalletProgress", "钱包充值进度", () => import("../views/WalletProgress.vue")),
  withLayout("/WalletRecords", "WalletRecords", "账单管理", () => import("../views/WalletRecords.vue")),
];

const PUBLIC_PATHS = new Set(["/", "/login", "/privacy-policy", "/terms"]);

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title == undefined ? "PanoMoBi" : String(to.meta.title);
  const isPublic = !!to.meta?.public || PUBLIC_PATHS.has(to.path);
  const token = localStorage.getItem("token");
  if (!isPublic && !token) {
    next("/login");
    return;
  }
  next();
});

export default router;
